export const SET_LEASE_END_TO_LAST_MONTH_TOGGLE_NAME =
  'isSetLeaseEndDateToEndOfMonth';
